




















import HeaderHeightMixin from 'library/mixins/header-height'
import BreakpointWatcherMixin from '~/components/globals/breakpoint-watcher-mixin'
import Logo from 'library/components/globals/logo'

# Hesitant to make site options a CMS Setting since sizing is made specifically
# for 4 sites and svg logo specific sizing
siteOptions = [
	{
		title: "Papa & Barkley",
		href: "https://www.papaandbarkley.com/",
		site: "brand"
	}
	{
		title: "Papa & Barkley CBD",
		href: "https://www.papaandbarkleycbd.com/",
		site: "cbd"
	}
	{
		title: "P&B Kitchen",
		href: "https://kitchen.papaandbarkley.com/",
		site: "kitchen"
	}
	{
		title: "Papa's Select",
		href: "https://www.papaselect.com/",
		site: "select"
	}
]

export default

	mixins: [ HeaderHeightMixin, BreakpointWatcherMixin ]

	components: { Logo }

	props:
		# Determines which height to use
		layout:
			type: String
			default: "desktop"
			validator: (str) -> str in ['desktop', 'mobile']

	# Make options available to component
	data: ->
		siteOptions: siteOptions

	computed:
		isMobile: -> !@breakpoints?.isMobileLandscapeUp

	methods:
		isCurrentSite: (site) -> site == @currentSite

		# The target attribute of the link
		linkTarget: (site) ->
			return if @isCurrentSite site
			return '_blank' if site == 'cbd'

